import { translate } from '../../i18n';

export type VenueIteration = 'v1' | 'v2' | 'v3';
export type VenueStatus = 'current' | 'superseded' | 'rejected';

export interface VenueVariant {
  id: string;
  iteration: VenueIteration;
  status: VenueStatus;
  name: string;
  pitch: string;
  optimizesFor: string;
  htmlPath: string;
  accent: string;
  /** True if this variant demonstrates the rotation engine (page rotation + sticky rule). */
  rotates?: boolean;
  /** Short note to surface in the showcase card when rotates=true. */
  rotationNote?: string;
}

export const ITERATION_META: Record<VenueIteration, { label: string; date: string; note: string }> = {
  v1: {
    label: translate('venue_display.iteration.v1_label'),
    date: '2026-04-24',
    note: translate('venue_display.iteration.v1_note'),
  },
  v2: {
    label: translate('venue_display.iteration.v2_label'),
    date: '2026-04-24',
    note: translate('venue_display.iteration.v2_note'),
  },
  v3: {
    label: translate('venue_display.iteration.v3_label'),
    date: '2026-04-25',
    note: translate('venue_display.iteration.v3_note'),
  },
};

export const VENUE_VARIANTS: VenueVariant[] = [
  {
    id: 'v3-calm',
    iteration: 'v3',
    status: 'current',
    name: translate('venue_display.variant.v3_calm.name'),
    pitch: translate('venue_display.variant.v3_calm.pitch'),
    optimizesFor: translate('venue_display.variant.v3_calm.optimizes_for'),
    htmlPath: '/venue-display/v3-calm.html',
    accent: '#E8A55A',
    rotates: true,
    rotationNote: translate('venue_display.variant.v3_calm.rotation_note'),
  },
  {
    id: 'v3-breathing',
    iteration: 'v3',
    status: 'current',
    name: translate('venue_display.variant.v3_breathing.name'),
    pitch: translate('venue_display.variant.v3_breathing.pitch'),
    optimizesFor: translate('venue_display.variant.v3_breathing.optimizes_for'),
    htmlPath: '/venue-display/v3-breathing.html',
    accent: '#E8A55A',
  },
  {
    id: 'v3-constellation',
    iteration: 'v3',
    status: 'current',
    name: translate('venue_display.variant.v3_constellation.name'),
    pitch: translate('venue_display.variant.v3_constellation.pitch'),
    optimizesFor: translate('venue_display.variant.v3_constellation.optimizes_for'),
    htmlPath: '/venue-display/v3-constellation.html',
    accent: '#E8A55A',
  },
  {
    id: 'v2-poster',
    iteration: 'v2',
    status: 'superseded',
    name: translate('venue_display.variant.v2_poster.name'),
    pitch: translate('venue_display.variant.v2_poster.pitch'),
    optimizesFor: translate('venue_display.variant.v2_poster.optimizes_for'),
    htmlPath: '/venue-display/v2-poster.html',
    accent: '#E8A75A',
  },
  {
    id: 'v2-floorplan',
    iteration: 'v2',
    status: 'superseded',
    name: translate('venue_display.variant.v2_floorplan.name'),
    pitch: translate('venue_display.variant.v2_floorplan.pitch'),
    optimizesFor: translate('venue_display.variant.v2_floorplan.optimizes_for'),
    htmlPath: '/venue-display/v2-floorplan.html',
    accent: '#F3C47E',
  },
  {
    id: 'v2-arrival',
    iteration: 'v2',
    status: 'superseded',
    name: translate('venue_display.variant.v2_arrival.name'),
    pitch: translate('venue_display.variant.v2_arrival.pitch'),
    optimizesFor: translate('venue_display.variant.v2_arrival.optimizes_for'),
    htmlPath: '/venue-display/v2-arrival.html',
    accent: '#F3C47E',
  },
  {
    id: 'v2-spotlight',
    iteration: 'v2',
    status: 'superseded',
    name: translate('venue_display.variant.v2_spotlight.name'),
    pitch: translate('venue_display.variant.v2_spotlight.pitch'),
    optimizesFor: translate('venue_display.variant.v2_spotlight.optimizes_for'),
    htmlPath: '/venue-display/v2-spotlight.html',
    accent: '#F3C47E',
  },
  {
    id: 'v1-atrium',
    iteration: 'v1',
    status: 'rejected',
    name: translate('venue_display.variant.v1_atrium.name'),
    pitch: translate('venue_display.variant.v1_atrium.pitch'),
    optimizesFor: translate('venue_display.variant.v1_atrium.optimizes_for'),
    htmlPath: '/venue-display/v1-atrium.html',
    accent: '#E8B464',
  },
  {
    id: 'v1-scoreboard',
    iteration: 'v1',
    status: 'rejected',
    name: translate('venue_display.variant.v1_scoreboard.name'),
    pitch: translate('venue_display.variant.v1_scoreboard.pitch'),
    optimizesFor: translate('venue_display.variant.v1_scoreboard.optimizes_for'),
    htmlPath: '/venue-display/v1-scoreboard.html',
    accent: '#00BFA6',
  },
  {
    id: 'v1-horizon',
    iteration: 'v1',
    status: 'rejected',
    name: translate('venue_display.variant.v1_horizon.name'),
    pitch: translate('venue_display.variant.v1_horizon.pitch'),
    optimizesFor: translate('venue_display.variant.v1_horizon.optimizes_for'),
    htmlPath: '/venue-display/v1-horizon.html',
    accent: '#F3C47E',
  },
  {
    id: 'v1-kinetic',
    iteration: 'v1',
    status: 'rejected',
    name: translate('venue_display.variant.v1_kinetic.name'),
    pitch: translate('venue_display.variant.v1_kinetic.pitch'),
    optimizesFor: translate('venue_display.variant.v1_kinetic.optimizes_for'),
    htmlPath: '/venue-display/v1-kinetic.html',
    accent: '#C6FF00',
  },
];
